<template>
  <div>
    <ResultStatus type="fail" :title="$t('fail_to_add_card')" style="margin-bottom: 120px;" />

    <md-button type="primary" style="margin-bottom: 60px;" @click="$router.replace({ name: 'CardAddBankAccount' })">{{ $t('tryAgain') }}</md-button>

    <md-button type="default" plain @click="$router.replace({ name: 'Card' })">{{ $t('back_to_homepage') }}</md-button>
  </div>
</template>

<script>
import { Icon, Button } from 'mand-mobile'
import ResultStatus from '@/components/ResultStatus'

// 成功状态
export default {
  name: 'Failed',

  components: {
    [Icon.name]: Icon,
    [Button.name]: Button,
    ResultStatus
  }
}
</script>

<style scoped lang="scss">
</style>
